import React from 'react';
export interface Testimonial {
  name: string;
  role: string;
  text: string;
  avatar?: string;
}
interface TestimonialsSectionProps {
  title?: string;
  subtitle?: string;
  badgeText?: string;
  testimonials: Testimonial[];
}
/**
 * Ejemplos de aplicación. Deliberadamente NO usa comillas, icono de cita ni
 * flechas: no son testimonios ni enlaces, sino escenarios ilustrativos.
 */
export function TestimonialsSection({
  title = 'Escenarios que una presencia bien resuelta puede transformar',
  subtitle = 'Ejemplos de aplicación del tipo de claridad, acompañamiento y experiencia que buscamos construir. No son testimonios ni casos verificables.',
  badgeText = 'Ejemplos de aplicación',
  testimonials
}: TestimonialsSectionProps) {
  return <section id="testimonials" className="section-shell border-t border-white/10 bg-black" aria-labelledby="testimonials-title" data-id="element-187" data-mp="483kflq038pg">
      <div className="container mx-auto max-w-6xl px-6 md:px-12" data-id="element-188" data-mp="37qwu3nfnrdec">
        <div className="grid gap-7 border-b border-white/10 pb-10 lg:grid-cols-[0.8fr_1.2fr] lg:items-end" data-id="element-189" data-mp="37oak7h5aolsy">
          <div data-id="element-190" data-mp="8sf71869axp8">
            <p className="eyebrow" data-id="element-191" data-mp="8rvopqcp27ao">{badgeText}</p>
            <h2 id="testimonials-title" className="mt-5 text-3xl font-medium tracking-[-0.045em] text-white sm:text-4xl" data-id="element-192" data-mp="8qkkxqj90zjk">
              {title}
            </h2>
          </div>
          <p className="max-w-2xl text-sm leading-relaxed text-neutral-300 sm:text-base" data-id="element-193" data-mp="hmjv5ju09v12">
            {subtitle}
          </p>
        </div>
        <div className="grid gap-5 pt-10 lg:grid-cols-2" data-id="element-194" data-mp="3ly5o44tm7wlh">
          {testimonials.map((example, index) => <article key={`${example.name}-${index}`} className="flex flex-col border border-white/10 bg-[#0a0a0a] p-7 sm:p-8" data-id="element-195" data-mp="3pzhi0mjiv3zh" data-mpi={index}>
              <div className="flex items-baseline justify-between gap-4 border-b border-white/10 pb-5" data-id="element-196" data-mp="15atco9k6rwme">
                <h3 className="text-sm font-medium text-white" data-id="element-197" data-mp="1a8v53l3i58aj">
                  {example.name}
                </h3>
                <span className="meta-number shrink-0" data-id="element-198" data-mp="36bhtnl9g2c3o">0{index + 1}</span>
              </div>
              <p className="mt-6 text-[15px] leading-relaxed text-neutral-200 sm:text-base" data-id="element-199" data-mp="32bpj530hpvvo">
                {example.text}
              </p>
              <p className="mt-auto pt-6 text-xs text-neutral-400" data-id="element-200" data-mp="3g8mglnb46blj">
                {example.role}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}